import React from 'react'
import { render } from 'react-dom'

import '../static/index.css'

import App from './App'

render(<App />, document.querySelector('#react-root'))